module.exports = __webpack_public_path__ + "img/parkdetail.722237f1.png";